import React from 'react';
import { DropdownField, MenuItem } from '@one-thd/sui-atomic-components';
import { Noop } from 'react-hook-form';
import { useAddress } from '../../hooks/use-address';

interface IAddressDropdownProps {
  selectedAddrID: number | null | undefined;
  onChange: (...event: React.ChangeEvent[]) => void;
  onBlur: Noop;
  disabled?: boolean | undefined;
  name: string;
  statusType: string | undefined;
  statusMessage: string | undefined;
}

export const AddressDropdownSelector = ({
  selectedAddrID,
  onChange,
  onBlur,
  disabled,
  name,
  statusType,
  statusMessage,
}: IAddressDropdownProps) => {
  const { addresses } = useAddress();

  // rename states
  const addressList = (addresses || []).slice();

  const selectedAddressIdx = addressList.findIndex(
    (address) => address?.id === selectedAddrID,
  );

  if (addressList.length > 1 && selectedAddressIdx > -1) {
    const [tempEl] = [...addressList];
    addressList[0] = addressList[selectedAddressIdx];
    addressList[selectedAddressIdx] = tempEl;
  }

  return (
    <DropdownField
      label="Billing Address *"
      status={statusType}
      statusMessage={statusMessage}
      fullWidth
      value={selectedAddrID}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event);
      }}
      disabled={disabled}
      dropdownProps={{
        'data-qm-mask': '',
        onBlur,
        name,
      }}
    >
      {addressList.slice(0, 20).map((address) => {
        const showAddressesLine2 = address?.postalAddress?.addressLine2
          ? ' ' + address?.postalAddress?.addressLine2
          : '';
        return (
          <MenuItem id={address?.id} key={address?.id} value={address?.id}>
            {address?.postalAddress?.addressLine1 +
              showAddressesLine2 +
              ', ' +
              address?.postalAddress?.city +
              ', ' +
              address?.postalAddress?.stateProvince +
              ', ' +
              address?.postalAddress?.zipCode}
          </MenuItem>
        );
      })}
    </DropdownField>
  );
};
